export const timingNames = [
  "after",
  "after end",
  "after start",
  "before",
  "before end",
  "before start",
  "during",
  "ends",
  "ends after",
  "ends after end",
  "ends after start",
  "ends before",
  "ends before end",
  "ends before start",
  "ends during",
  "ends properly during",
  "ends same as",
  "ends same as end",
  "ends same as start",
  "ends same or after",
  "ends same or after end",
  "ends same or after start",
  "ends same or before",
  "ends same or before end",
  "ends same or before start",
  "included in",
  "meets",
  "meets after",
  "meets before",
  "overlaps",
  "overlaps after",
  "overlaps before",
  "properly during",
  "properly included in",
  "same as",
  "same as end",
  "same as start",
  "same or after",
  "same or after end",
  "same or after start",
  "same or before",
  "same or before end",
  "same or before start",
  "starts",
  "starts after",
  "starts after end",
  "starts after or on",
  "starts after or on end",
  "starts after or on start",
  "starts after start",
  "starts before",
  "starts before end",
  "starts before or on",
  "starts before or on end",
  "starts before or on start",
  "starts before start",
  "starts during",
  "starts on or before",
  "starts on or before end",
  "starts on or before start",
  "starts properly during",
  "starts same as",
  "starts same as end",
  "starts same as start",
  "starts same or after",
  "starts same or after end",
  "starts same or after start",
  "starts same or before",
  "starts same or before end",
  "starts same or before start",
];
export const predefinedFunctionsNames = [
  "Abs()",
  "AgeInDays()",
  "AgeInDaysAt()",
  "AgeInHours()",
  "AgeInHoursAt()",
  "AgeInMinutes()",
  "AgeInMinutesAt()",
  "AgeInMonths()",
  "AgeInMonthsAt()",
  "AgeInSeconds()",
  "AgeInSecondsAt()",
  "AgeInWeeks()",
  "AgeInWeeksAt()",
  "AgeInYears()",
  "AgeInYearsAt()",
  "AllTrue()",
  "AnyTrue()",
  "Avg()",
  "CalculateAgeInDays()",
  "CalculateAgeInDaysAt()",
  "CalculateAgeInHours()",
  "CalculateAgeInHoursAt()",
  "CalculateAgeInMinutes()",
  "CalculateAgeInMinutesAt()",
  "CalculateAgeInMonths()",
  "CalculateAgeInMonthsAt()",
  "CalculateAgeInSeconds()",
  "CalculateAgeInSecondsAt()",
  "CalculateAgeInWeeks()",
  "CalculateAgeInWeeksAt()",
  "CalculateAgeInYears()",
  "CalculateAgeInYearsAt()",
  "Ceiling()",
  "Coalesce()",
  "Count()",
  "DateTime()",
  "Exp()",
  "First()",
  "Floor()",
  "GeometricMean()",
  "HighBoundary()",
  "IndexOf()",
  "Last()",
  "Length()",
  "Ln()",
  "Log()",
  "LowBoundary()",
  "Lower()",
  "Matches()",
  "Max()",
  "Median()",
  "Min()",
  "Mode()",
  "Now()",
  "PopulationStdDev()",
  "PopulationVariance()",
  "Precision()",
  "Product()",
  "Round()",
  "Size()",
  "Skip()",
  "Split()",
  "SplitOnMatches()",
  "StartsWith()",
  "StdDev()",
  "Substring()",
  "Sum()",
  "Tail()",
  "Take()",
  "Time()",
  "TimeOfDay()",
  "ToBoolean()",
  "ToDate()",
  "ToDateTime()",
  "Today()",
  "ToDecimal()",
  "ToInteger()",
  "ToQuantity()",
  "ToString()",
  "ToTime()",
  "Truncate()",
  "Upper()",
  "Variance()",
];
